import { SoundTransform } from "./SoundTransform";
import { getLogger } from "@goodgamestudios/logger";
import EventDispatcher = createjs.EventDispatcher;

const logger = getLogger("sound");

export class SoundChannel extends EventDispatcher {
    public readonly leftPeak: number;
    public readonly rightPeak: number;

    public soundInstance: createjs.AbstractSoundInstance;

    private _soundTranform: SoundTransform;

    public stop(): void {
        if (this.soundInstance) {
            this.soundInstance.stop();
        } else {
            setTimeout(() => {
                this.stop();
            }, 50);
        }
    }

    public get soundTransform() {
        return this._soundTranform;
    }

    public set soundTransform(st: SoundTransform) {
        this._soundTranform = st;
        if (this.soundInstance) {
            this.soundInstance.applyPlayProps({
                pan: st.pan,
                volume: st.volume
            });
        }
    }

    public get position(): number {
        if (this.soundInstance) {
            return this.soundInstance.position;
        } else {
            return 0;
        }
    }
}
